"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var FormContext_1 = require("./FormContext");

var INPUT_VALUE_DEFAULT = "";

var withValidation = function withValidation(FieldComponent) {
  return React.memo(function (props) {
    var _a = React.useContext(FormContext_1.ValidationsContext),
        formFields = _a.formFields,
        validateField = _a.validateField,
        submitted = _a.submitted,
        textValidation = _a.textValidation;

    var name = props.name,
        placeholder = props.placeholder,
        label = props.label,
        _b = props.value,
        value = _b === void 0 ? INPUT_VALUE_DEFAULT : _b,
        type = props.type,
        inputMode = props.inputMode,
        multiRows = props.multiRows,
        rows = props.rows,
        focused = props.focused,
        prependIcon = props.prependIcon,
        prependLabel = props.prependLabel,
        appendLabel = props.appendLabel,
        minLength = props.minLength,
        maxLength = props.maxLength,
        pattern = props.pattern,
        required = props.required,
        autoCapitalize = props.autoCapitalize,
        autoCorrect = props.autoCorrect,
        onChange = props.onChange,
        onSubmit = props.onSubmit,
        onBlur = props.onBlur,
        onFocus = props.onFocus;
    var validation = {
      required: required,
      type: type,
      minLength: minLength,
      pattern: pattern
    };
    var setFormFields = React.useCallback(function (valueField) {
      validateField(name, {
        value: valueField,
        validation: validation
      });
    }, [name, validateField, validation]);
    var handleChange = React.useCallback(function (event) {
      onChange === null || onChange === void 0 ? void 0 : onChange(event);
    }, [onChange]);
    var handleBlur = React.useCallback(function (event) {
      setFormFields(event.value);
      onBlur === null || onBlur === void 0 ? void 0 : onBlur(event);
    }, [onBlur, setFormFields]);
    React.useEffect(function () {
      setFormFields(value);
    }, []);
    var showError = React.useCallback(function (nameField, error) {
      if (error && textValidation) {
        return {}.hasOwnProperty.call(textValidation, nameField) ? textValidation[nameField] : error;
      }

      return null;
    }, [textValidation]);
    var error = submitted && formFields[name] && showError(name, formFields[name].error) ? showError(name, formFields[name].error) : "";
    var appearanceError = error ? "validation_error" : "default";
    return React.createElement(FieldComponent, {
      name: name,
      placeholder: placeholder,
      label: label,
      value: value,
      type: type,
      inputMode: inputMode,
      multiRows: multiRows,
      rows: rows,
      focused: focused,
      prependIcon: prependIcon,
      prependLabel: prependLabel,
      appendLabel: appendLabel,
      minLength: minLength,
      maxLength: maxLength,
      pattern: pattern,
      required: required,
      autoCapitalize: autoCapitalize,
      autoCorrect: autoCorrect,
      onSubmit: onSubmit,
      onFocus: onFocus,
      onChange: handleChange,
      onBlur: handleBlur,
      appearance: appearanceError,
      helpText: error
    });
  });
};

exports.default = withValidation;